import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getEmail, getToken } from "../utils/auth";
import { FaBook, FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import './StudyMaterial.css';

const StudentStudyMaterialList = () => {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Define the async function inside the effect
    const fetchMaterials = async () => {
      try {
        // Use the environment variable from your .env file
        const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:3000";

        const response = await fetch(`${baseUrl}/getStudyMaterialsByStudent`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getToken()}`
          },
          body: JSON.stringify({ email: getEmail() }), 
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        // Ensure we are setting an array even if the API structure varies
        setMaterials(data.materials || []);
      } catch (error) {
        console.error("Error fetching study materials:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMaterials();
  }, []);

  if (loading) return (
    <div className="loading-state">
      <div className="loading-content">
        <FaBook className="loading-icon" />
        <h2>Loading your study materials...</h2>
        <p>Please wait while we fetch your content</p>
      </div>
    </div>
  );

  return (
    <div className="study-list-container">
      <h1 className="page-title">My Study Materials</h1>
      
      <div className="course-grid">
        {materials.length > 0 ? (
          materials.map((item) => (
            <div 
              key={item._id} 
              className="course-card"
              onClick={() => navigate(`/study-material-content`, { state: { material: item } })}
            >
              <div className="card-content">
                <span className="category-tag"><FaBook /> Course</span>
                <h2 className="course-name">{item.course}</h2>
                <p className="update-date">
                  <FaCalendarAlt /> Last updated: {new Date(item.updatedAt).toLocaleDateString()}
                </p>
              </div>
              <div className="card-footer">
                <span>View Material</span>
                <FaArrowRight className="arrow-icon" />
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">
            <p>No study materials found for your account.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentStudyMaterialList;